import SyDropdown from "./sy-dropdown";

export default SyDropdown